import type { SurveyLanguage } from '../types/surveyLanguage';

export const SURVEY_LANGUAGE_STORAGE_KEY = 'ldsurvey:surveyLanguage';

export const SURVEY_LANGUAGE_CODES: readonly SurveyLanguage[] = ['en', 'bm', 'cn'] as const;

export function isSurveyLanguage(value: string | null | undefined): value is SurveyLanguage {
  return value === 'en' || value === 'bm' || value === 'cn';
}
